import request from "@/config/utils/request";
// 查询海报
export function selectSubconPosters(data) {
  return request({
    url: "/apis/scp/SubConPoster/users/signup/selectSubconPosters",
    method: "post",
    data
  });
}

// 新增点击记录
export function insertSubconPosterClick(data) {
  return request({
    url: "/apis/scp/SubConPoster/users/signup/insertSubconPosterClick",
    method: "post",
    data
  });
}
